module.exports = __webpack_public_path__ + "img/13.e3475702.jpg";